import {
    Card,
    CardActionArea,
    Box,
    Chip,
    Avatar,
    CardContent,
    Typography,
    Skeleton,
    Rating,
  } from "@mui/material";
  
  const CardSkeleton = () => {
    return (
      <Card
        sx={{
          borderRadius: 2,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        <CardActionArea>
          <Box
            sx={{
              height: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #f0f0f0, #e0e0e0)",
              position: "relative",
            }}
          >
            <Chip
              label={<Skeleton width={50} height={20} />}
              sx={{
                top: 5,
                right: 5,
                height: 25,
                position: "absolute",
                borderRadius: "6px",
                background: "#e0e0e0",
                color: "transparent",
              }}
            />
            <Skeleton
              variant="circular"
              sx={{
                height: 120,
                width: 120,
                border: "4px solid #fff",
                zIndex: 1,
              }}
            />
          </Box>
  
          {/* Card Content */}
          <CardContent>
            <Typography gutterBottom variant="h6" fontWeight="600" noWrap>
              <Skeleton width="80%" />
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              <Skeleton width="100%" />
              <Skeleton width="90%" />
              <Skeleton width="80%" />
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
              <Skeleton variant="rectangular" width={100} height={20} />
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  };
  
  export default CardSkeleton;
  